// Package Imports
import { PipeTransform } from '@angular/core';

export class SearchSettings {
  fieldName: string;
  pipe?: PipeTransform;
}
